import { Box, Grid } from '@mui/material';
import { getPurePlaybookList } from '@Store/feature/purePlaybookSlice';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { Icons } from '../../../assets/SvgIcons';
import { NoItem } from '../../../assets/SvgIcons/NoItem';
import BasicCard from '../../../components/UI/BasicCard/BasicCard';
import CustomCard from '../../../components/UI/CustomCard/CustomCard';
import SankeyCard, {
  SankeyData,
} from '../../../components/UI/SankeyCard/SankeyCard';
import TodoCard from '../../../components/UI/TodoCard/TodoCard';
import { PageType, TaskViewType } from '../../../config/enum';
import { FilterIProps } from '../../../config/filter';
import { ICTask } from '../../../helper/Interfaces';
import { getAssets } from '../../../store/feature/assetsSlice';
import { useAppSelector } from '../../../store/hooks';
import PieChartRisk from '../../Risk/components/PieChartRisk';

interface DependencyOverviewTabProps {
  dealTaskList: Array<ICTask>;
  setdirectedFilters: (value: React.SetStateAction<FilterIProps[]>) => void;
  setTabValue: (value: React.SetStateAction<string>) => void;
  isImo: boolean;
}
export default function OverviewTab(props: DependencyOverviewTabProps) {
  const { dealTaskList, setdirectedFilters, setTabValue, isImo } = props;
  const { functionalAreas } = useAppSelector(getAssets);
  const purePlaybooks = useAppSelector(getPurePlaybookList);
  console.log('purePlaybooks', purePlaybooks);

  let navigate = useNavigate();
  const { id } = useParams();
  let dependenciesOutSankey = [] as SankeyData[];
  let dependenciesIncomingSankey = [] as SankeyData[];
  const targetFunctions = purePlaybooks?.filter(
    a => a.project.workspaceId === id!
  );
  console.log('targetFunctions', targetFunctions);

  const { t } = useTranslation();

  const dependenciesIn = dealTaskList.filter(i =>
    targetFunctions
      ?.map(t => t.functionalAreaId)
      .includes(i.dependencySource ?? '')
  );
  const dependenciesOut = dealTaskList.filter(i =>
    targetFunctions
      ?.map(t => t.functionalAreaId)
      .includes(i.dependencyTarget ?? '')
  );
  if (dependenciesIn) {
    for (const item of dependenciesIn) {
      const depIn = {
        source:
          (purePlaybooks?.find(
            f => f.functionalAreaId === item.dependencySource
          )?.project.taskPrefix ?? '') + ' out',
        target:
          (purePlaybooks?.find(
            f => f.functionalAreaId === item.dependencyTarget
          )?.project.taskPrefix ?? '') + ' in',
        value: Array.from(
          new Set(
            dependenciesIn
              .filter(
                d =>
                  d.dependencySource === item.dependencySource &&
                  d.dependencyTarget === item.dependencyTarget
              )
              .map(i => i.id)
          )
        ).length,
        color:
          functionalAreas?.find(f => f.id === item.dependencySource)?.color ??
          '',
      };
      if (
        dependenciesOutSankey.filter(
          i =>
            i.source === depIn.source &&
            i.target === depIn.target &&
            i.value === depIn.value
        ).length === 0 &&
        depIn.value > 0
      ) {
        dependenciesOutSankey.push(depIn);
      }
    }
  }
  if (dependenciesOut) {
    for (const item of dependenciesOut) {
      const depOut = {
        source:
          (purePlaybooks?.find(
            f => f.functionalAreaId === item.dependencySource
          )?.project.taskPrefix ?? '') + ' out',
        target:
          (purePlaybooks?.find(
            f => f.functionalAreaId === item.dependencyTarget
          )?.project.taskPrefix ?? '') + ' in',
        value: Array.from(
          new Set(
            dependenciesOut
              .filter(
                d =>
                  d.dependencyTarget === item.dependencyTarget &&
                  d.dependencySource === item.dependencySource
              )
              .map(i => i.id)
          )
        ).length,
        color:
          functionalAreas?.find(f => f.id === item.dependencySource)?.color ??
          '',
      };
      if (
        dependenciesIncomingSankey.filter(
          i =>
            i.source === depOut.source &&
            i.target === depOut.target &&
            i.value === depOut.value
        ).length === 0 &&
        depOut.value > 0
      ) {
        dependenciesIncomingSankey.push(depOut);
      }
    }
  }

  const dependenciesIncomingSankeyClick = (sankey: any) => {
    console.log({ sankey });
    const source = sankey[0].data.data.source?.split(' out')[0];
    const target = sankey[0].data.data.target?.split(' in')[0];

    console.log(source, target);
    if (isImo) {
      navigate(
        '/dependencies/' +
          id +
          `?tabIndex=2&dependencTab=incoming&source=${source}&target=${target}`
      );
    } else {
      navigate(
        '/dependencies-in/' +
          id +
          `?tabIndex=2&dependencTab=incoming&source=${source}&target=${target}`
      );
    }
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={6} md={4}>
          <CustomCard
            title={t('dependencies.total.total_dependencies_title')}
            titleIcon={<Icons.Dependency />}
            hideBorderTitleIcon
            tooltip={t('dependencies.total.total_dependencies_tooltip')}
            content={
              <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                  <BasicCard
                    title={t('dependencies.total.new_active')}
                    text={Array.from(
                      new Set(
                        dealTaskList
                          .filter(
                            dt =>
                              moment(new Date()).diff(dt.createdAt, 'days') <= 7
                          )
                          .map(i => i.id)
                      )
                    ).length.toString()}
                    className={
                      dealTaskList.filter(
                        dt => moment(new Date()).diff(dt.createdAt, 'days') <= 7
                      ).length > 0
                        ? 'clickable'
                        : ''
                    }
                    clickHandler={() => {
                      const rangeFilter: FilterIProps[] = [];
                      console.log('mom', moment().format('MM-DD-YYYY'));

                      rangeFilter.push({
                        key: moment().format('MM-DD-YYYY'),
                        value: 'Due Date ' + moment().format('MM-DD-YYYY'),
                      });
                      setdirectedFilters([...rangeFilter]);
                      setTabValue('2');
                    }}
                    grayMode
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BasicCard
                    title={t('dependencies.total.total_actives')}
                    clickHandler={() => {
                      const moreFilter: FilterIProps[] = [];
                      moreFilter.push({
                        key: 'uncompleted',
                        value: 'Uncompleted only',
                      });
                      setdirectedFilters([...moreFilter]);
                      setTabValue('2');
                    }}
                    className={
                      dealTaskList.filter(a => a.isCompleted === false).length >
                      0
                        ? 'clickable'
                        : ''
                    }
                    text={Array.from(
                      new Set(
                        dealTaskList
                          .filter(a => a.isCompleted === false)
                          .map(i => i.id)
                      )
                    ).length.toString()}
                    grayMode
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BasicCard
                    title={t('dependencies.total.completed')}
                    clickHandler={() => {
                      const moreFilter: FilterIProps[] = [];
                      moreFilter.push({
                        key: 'completed',
                        value: 'Completed only',
                      });
                      setdirectedFilters([...moreFilter]);
                      setTabValue('2');
                    }}
                    text={Array.from(
                      new Set(
                        dealTaskList
                          .filter(a => a.isCompleted === true)
                          .map(i => i.id)
                      )
                    ).length.toString()}
                    className={
                      dealTaskList.filter(a => a.isCompleted === true).length >
                      0
                        ? 'clickable'
                        : ''
                    }
                    grayMode
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <BasicCard
                    title={t('dependencies.total.total_dependencies')}
                    clickHandler={() => {
                      setTabValue('2');
                    }}
                    text={Array.from(
                      new Set(
                        dealTaskList.filter(i => !i.isCompleted).map(i => i.id)
                      )
                    ).length.toString()}
                    className={
                      dealTaskList.filter(a => !a.isCompleted).length > 0
                        ? 'clickable'
                        : ''
                    }
                    grayMode
                  />
                </Grid>
              </Grid>
            }
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <CustomCard
            title={t('dependencies.resolution_progress')}
            tooltip={t('dependencies.resolution_progress_tooltip')}
            content={
              dealTaskList.length > 0 ? (
                <PieChartRisk
                  firstTitle="Completed"
                  firstValue={
                    Array.from(
                      new Set(
                        dealTaskList
                          .filter(t => t.isCompleted === true)
                          .map(i => i.id)
                      )
                    ).length
                  }
                  secondTitle="Uncompleted"
                  secondValue={
                    Array.from(
                      new Set(
                        dealTaskList
                          .filter(t => t.isCompleted === false)
                          .map(i => i.id)
                      )
                    ).length
                  }
                />
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    flex: 1,
                    justifyContent: 'center',
                    paddingTop: 30,
                  }}
                >
                  <NoItem />
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 5,
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginLeft: 15,
                      fontFamily: 'Inter',
                      color: '#253858',
                      fontWeight: 600,
                    }}
                  >
                    <span>No Dependency</span>
                  </div>
                </div>
              )
            }
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <CustomCard
            title={
              isImo
                ? t('dependencies.dependencies_header')
                : t('dashboard.dependencies_incoming')
            }
            tooltip={t('dashboard.dependencies_incoming_tooltip')}
            overFlow
            autoHeight
            content={
              <>
                {dependenciesIncomingSankey?.length > 0 ? (
                  <SankeyCard
                    key={1}
                    data={dependenciesIncomingSankey}
                    onClick={dependenciesIncomingSankeyClick}
                  />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      flex: 1,
                      justifyContent: 'center',
                      paddingTop: 30,
                    }}
                  >
                    <NoItem />
                    <div
                      style={{
                        display: 'flex',
                        marginTop: 5,
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: 15,
                        fontFamily: 'Inter',
                        color: '#253858',
                        fontWeight: 600,
                      }}
                    >
                      <span>{t('dashboard.no_dependencies_incoming')}</span>
                    </div>
                  </div>
                )}
              </>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomCard
            titleIcon={<></>}
            hideBorderTitleIcon
            overFlow
            autoHeight
            title={
              isImo
                ? t('dependencies.dependencies_header')
                : t('dashboard.dependencies_incoming')
            }
            content={
              <div className="task-gray-content">
                {dealTaskList.filter(
                  i =>
                    targetFunctions
                      ?.map(t => t.functionalAreaId)
                      .includes(i.dependencyTarget ?? '') &&
                    i.parentTaskName !== undefined
                ).length > 0 ? (
                  dealTaskList.map(t => {
                    return (
                      <TodoCard
                        key={t.id}
                        task={t}
                        isFromList={true}
                        pageType={PageType.DEPENDENCIES}
                        startDate={null}
                        subTaskCount={0}
                        taskViewType={TaskViewType.BOARD}
                        shadowTitle={
                          t.name === ' '
                            ? '(' +
                              (purePlaybooks?.find(
                                f => f.functionalAreaId === t.dependencySource
                              )?.project.taskPrefix ?? '') +
                              ' - ' +
                              (purePlaybooks?.find(
                                f => f.functionalAreaId === t.dependencyTarget
                              )?.project.taskPrefix ?? '') +
                              ') ' +
                              (t.parentTaskName ?? '')
                            : t.name
                        }
                        hideMoreIcon
                      />
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                      flexDirection: 'column',
                      textAlign: 'center',
                      mt: 4,
                    }}
                  >
                    <Box sx={{ margin: 'auto' }}>
                      <NoItem />
                    </Box>
                    <span>{t('dashboard.no_dependencies_incoming')}</span>
                  </Box>
                )}
              </div>
            }
          />
        </Grid>
      </Grid>
      <div style={{ height: 30 }}></div>
    </div>
  );
}
